import React, { useMemo } from 'react'

import MerchantSelect from '@components/operator/MerchantSelect'
import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService'
import InventoryMonitorsEdit from '@shared/inventory_monitors/InventoryMonitorsEdit'

import { inventoryMonitorService } from '@services/operator/inventoryMonitorService'

function InventoryMonitorNewContent() {
  const { merchantInventoryTypes, merchants, currentMerchant } = useOperatorData()
  const productService = useOperatorProductService()

  const merchantOptions = useMemo(
    () => (merchants ?? []).map(m => ({ value: m.id, label: m.name })),
    [merchants]
  )

  const inventoryTypes = useMemo(() => {
    if (!currentMerchant?.id) return []
    return (merchantInventoryTypes ?? [])
      .filter(mit => mit.merchant_id === currentMerchant.id && mit.enabled !== false)
      .map(mit => mit.inventory_type)
  }, [merchantInventoryTypes, currentMerchant?.id])

  // <MerchantSelect> 已在外層 gate；本元件 mount 時 currentMerchant 必存在。
  // TS narrow（放在所有 hook 之後）。
  if (!currentMerchant?.id) return null

  return (
    <InventoryMonitorsEdit
      inventoryMonitorService={inventoryMonitorService}
      productService={productService}
      inventoryTypes={inventoryTypes}
      merchantOptions={merchantOptions}
      merchantIdForCreate={currentMerchant.id}
      role="operator"
    />
  )
}

export default function OperatorInventoryMonitorNew() {
  return (
    <MerchantSelect>
      <InventoryMonitorNewContent />
    </MerchantSelect>
  )
}
